import React, { useEffect } from 'react'
import { Image, Platform, StyleSheet } from 'react-native'

import { translate } from '../../i18n'
import { DS } from '../../design-system'
import { NotificationScreenLayout } from '../../components/Notifications/NotificationScreenLayout'
import RealTimeUpdate from '../../../assets/Onboarding/RealTimeUpdate.png'
import { useThrottledCallback } from 'use-debounce'
import { DSIcon } from '../../design-system/Icon'
import { ensurePushEnabled } from '@/modules/push'
import { observer } from 'mobx-react-lite'
import { Redirect, useRouter } from 'expo-router'
import { events } from '@/models/analytics/analytics-events'
import { useStore } from '@/models'

const items = [
  {
    icon: 'One',
    textKey: 'realTimeUpdates.itemOne'
  },
  {
    icon: 'Two',
    textKey: 'realTimeUpdates.itemTwo'
  },
  {
    icon: 'Three',
    textKey: 'realTimeUpdates.itemThree'
  }
]

const isWeb = Platform.OS === 'web'
const ENABLE_NOTIFICATIONS = !isWeb

export const RealTimeUpdatesScreen = observer(() => {
  const router = useRouter()
  const store = useStore()

  const userId = store.session.user?._id.toString()

  const enableNotifications = useThrottledCallback(() => {
    router.navigate('/onboarding/start-playing')
    //store.permissions.setPushPermissionRequestedAt(Date.now())
    ensurePushEnabled(true)
    store.analytics.setEvent(events.realtimeUpdates.onboarding_notif_button_enable, {
      userId,
      screen_name: 'onboarding_notif'
    })
  }, 1000)

  const notEnableNotifications = useThrottledCallback(() => {
    //store.permissions.setPushPermissionRequestedAt(Date.now())
    router.navigate('/onboarding/start-playing')
    store.analytics.setEvent(events.realtimeUpdates.onboarding_notif_button_skip, {
      userId,
      screen_name: 'onboarding_notif'
    })
  }, 1000)

  useEffect(() => {
    store.analytics.setEvent(events.realtimeUpdates.onboarding_notif_screen_viewed, {
      userId,
      screen_name: 'onboarding_notif'
    })
  }, [store.analytics.setEvent, userId])

  if (!ENABLE_NOTIFICATIONS) {
    return <Redirect href={'/onboarding/start-playing'} />
  }
  return (
    <NotificationScreenLayout
      firstButtonLabel="Turn on notifications"
      secondButtonLabel="Not right now"
      onFirstButtonPress={enableNotifications}
      onSecondButtonPress={notEnableNotifications}
    >
      <DS.Frame style={styles.centerFrame}>
        <Image source={RealTimeUpdate} style={styles.image} />
        <DS.Frame style={styles.content}>
          <DS.Text variant="Heading 2/Medium" textAlign="center">
            {translate('realTimeUpdates.title')}
          </DS.Text>
          <DS.Frame style={styles.items}>
            {items.map((item, key) => (
              <DS.Frame style={styles.row} key={key}>
                <DS.Icon name={item.icon as DSIcon} size={40} />
                <DS.Text variant="Body Large/Medium" style={styles.text}>
                  {translate(item.textKey)}
                </DS.Text>
              </DS.Frame>
            ))}
          </DS.Frame>
        </DS.Frame>
      </DS.Frame>
    </NotificationScreenLayout>
  )
})

const styles = StyleSheet.create({
  centerFrame: {
    alignItems: 'center',
    gap: 32
  },
  image: { width: 96, height: 96 },
  content: {
    gap: 16
  },
  items: {
    gap: 8
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12
  },
  text: {
    flex: 1,
    flexWrap: 'wrap'
  }
})
